/* Tha Layover — floating back to top with scroll progress ring */
(function () {
  'use strict';
  var btn = document.querySelector('[data-tl-btt]');
  if (!btn) return;
  var bar = btn.querySelector('.tl-btt-bar');
  var ticking = false, visible = false;

  /* Horizon scrolls inside .page-wrapper (html/body overflow hidden); fall back to the window */
  function scroller() {
    var w = document.querySelector('.page-wrapper');
    if (w && /(auto|scroll)/.test(getComputedStyle(w).overflowY) && w.scrollHeight > w.clientHeight + 1) return w;
    return null;
  }
  var el = scroller();
  function pos() { return el ? el.scrollTop : window.scrollY; }
  function max() { return el ? el.scrollHeight - el.clientHeight : document.documentElement.scrollHeight - window.innerHeight; }

  function update() {
    ticking = false;
    var y = pos(), m = max();
    bar.style.strokeDashoffset = String(100 - (m > 0 ? Math.min(1, y / m) : 0) * 100);
    var on = y > window.innerHeight * 0.6;
    if (on !== visible) {
      visible = on;
      btn.classList.toggle('is-visible', on);
      btn.tabIndex = on ? 0 : -1;
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function bind() {
    var next = scroller();
    if (next === el && bind.done) return;
    (el || window).removeEventListener('scroll', onScroll);
    el = next; bind.done = true;
    (el || window).addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  bind();
  window.addEventListener('resize', function () { bind(); onScroll(); });
  window.addEventListener('load', bind);

  btn.addEventListener('click', function () {
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    (el || window).scrollTo({ top: 0, behavior: behavior });
    var target = document.querySelector('[data-tl-header] a, header a');
    if (target) target.focus({ preventScroll: true });
  });
})();
